import { CognitoIdentityProvider } from '@mesa-labs/mesa-ui';

export function createCognitoIdentityProvider(region: string, clientId: string, userPoolId: string) {
  return new CognitoIdentityProvider({
    region,
    clientId,
    userPoolId
  });
}
